module.exports = __webpack_public_path__ + "img/9-05.8cc82bdc.png";